import SimpleTablePage from "../common/SimpleTablePage";
import { Card, Input, Select, Typography } from "antd";
import DebounceSelect from "../common/DebounceSelect";
import { api } from "../common/api";
import React from "react";
import { CalendarOutlined, ToolOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Link } from "react-router";
import StatCard from "../components/StatCard";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    sorter: true,
    key: "id",
    fixed: "left",
    width: 70,
    render: (id) => <Link to={`${id}`}>{id}</Link>,
  },
  {
    title: "Codice seriale",
    key: "serialCode",
    dataIndex: "serialCode",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Categoria",
    key: "equipmentType",
    dataIndex: "equipmentType",
    render: (_, record) => record.type?.name,
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Descrizione",
    key: "description",
    dataIndex: "description",
    sorter: true,
    ellipsis: true,
    width: 100,
  },
  {
    title: "Stato",
    key: "state",
    dataIndex: "state",
    ellipsis: true,
    width: 100,
    render: (_, record) =>
      record.assignment ? `Assegnato (${record.assignment.employee.fullName})` : "Disponibile",
  },
];


const entityFilter = (name, label, resource, queryParam, getLabel) => ({
  name,
  label,
  readableValue: (value) => value && JSON.parse(value).label,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value && JSON.parse(value) }),
      normalize: (value) => value && JSON.stringify(value),
    },
    children: (
      <DebounceSelect
        allowClear
        minSize={0}
        fetchOptions={(query) =>
          api[resource]
            .list({ [queryParam]: query, pageSize: 9999 })
            .then(({ data }) => data.map((item) => ({ label: getLabel(item), value: item.id })))
        }
      />
    ),
  },
});

const filterItems = [
  { name: "serialCode", label: "Codice seriale", formItem: { children: <Input allowClear /> } },
  { name: "description", label: "Descrizione", formItem: { children: <Input allowClear /> } },
  entityFilter("equipmentType", "Categoria", "equipmentType", "name", (item) => item.name),
  entityFilter("employee", "Dipendente", "employee", "query", (item) => item.fullName),
  {
    name: "assigned",
    label: "Stato",
    readableValue: (value) => (value === "true" ? "Assegnato" : "Disponibile"),
    formItem: {
      children: (
        <Select
          allowClear
          options={[
            { label: "Assegnato", value: "true" },
            { label: "Disponibile", value: "false" },
          ]}
        />
      ),
    },
  },
];

const fetchEquipment = (params) =>
  api.equipment.list({
    ...params,
    equipmentType: params.equipmentType ? JSON.parse(params.equipmentType).value : undefined,
    employee: params.employee ? JSON.parse(params.employee).value : undefined,
  });

export default function Equipments() {
  return (
    <div style={{ display: "flex", flexDirection: "column", rowGap: 24 }}>
      <SimpleTablePage
        title={"Attrezzature"}
        description={"Crea,assegna e gestisci le attrezzature"}
        resource="equipment"
        columns={columns}
        filterItems={filterItems}
        fetchFunction={fetchEquipment}
        showAdd={false}
      >
        {/*<div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <StatCard title={"Totale attrezzature"} icon={<ToolOutlined />} stat={150} />
          <StatCard
            title={"Assegnate"}
            icon={<UserOutlined style={{ color: "green" }} />}
            stat={80}
            secondary={"75% dell'inventario"}
          />
          <StatCard
            title={"Revisioni in scadenza"}
            icon={<CalendarOutlined />}
            stat={38}
            secondary={"Entro 30 giorni"}
          />
          <StatCard
            title={"Revisioni scadute"}
            icon={<WarningOutlined />}
            stat={5}
            secondary={"Richiedono attenzione"}
          />
        </div>*/}
      </SimpleTablePage>
    </div>
  );
}
